// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.eventlogger

import org.multipaz.cbor.DataItem
import org.multipaz.eventlogger.EventVerificationIso18013Proximity
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItemDateTimeString
import org.multipaz.cbor.buildCborMap
import org.multipaz.verification.PresentmentRecord
import org.multipaz.mdoc.transport.NfcHybridTransportStats
import org.multipaz.mdoc.engagement.EngagementType
import kotlin.time.Duration
import org.multipaz.verification.toDataItem
import org.multipaz.mdoc.transport.toDataItem
import org.multipaz.verification.fromDataItem
import org.multipaz.mdoc.transport.fromDataItem

fun EventVerificationIso18013Proximity.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "H-K3uqxp5yu805QK_V8Mb3781ZSJSH6SuLnnouoKlxo")
val EventVerificationIso18013Proximity_cborSchemaId = ByteString(31, -30, -73, -70, -84, 105, -25, 43, -68, -45, -108, 10, -3, 95, 12, 111, 126, -4, -43, -108, -119, 72, 126, -110, -72, -71, -25, -94, -22, 10, -105, 26)

fun EventVerificationIso18013Proximity.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "VerificationIso18013Proximity")
    builder.put("identifier", Tstr(this.identifier))
    builder.put("timestamp", this.timestamp.toDataItemDateTimeString())
    val map = this.appData.let {
        buildCborMap {
            for (entry in it.entries) {
                put(Tstr(entry.key), entry.value)
            }
        }
    }
    builder.put("appData", map)
    builder.put("presentmentRecord", this.presentmentRecord.toDataItem())
    builder.put("engagementType", Tstr(this.engagementType.name))
    val durationNfcTapToEngagement = this.durationNfcTapToEngagement
    if (durationNfcTapToEngagement != null) {
        builder.put("durationNfcTapToEngagement", Tstr(durationNfcTapToEngagement.toIsoString()))
    }
    val durationEngagementReceivedToRequestSent = this.durationEngagementReceivedToRequestSent
    if (durationEngagementReceivedToRequestSent != null) {
        builder.put("durationEngagementReceivedToRequestSent", Tstr(durationEngagementReceivedToRequestSent.toIsoString()))
    }
    val durationRequestSentToResponseReceived = this.durationRequestSentToResponseReceived
    if (durationRequestSentToResponseReceived != null) {
        builder.put("durationRequestSentToResponseReceived", Tstr(durationRequestSentToResponseReceived.toIsoString()))
    }
    val durationScanningTime = this.durationScanningTime
    if (durationScanningTime != null) {
        builder.put("durationScanningTime", Tstr(durationScanningTime.toIsoString()))
    }
    val nfcHybridTransportStats = this.nfcHybridTransportStats
    if (nfcHybridTransportStats != null) {
        builder.put("nfcHybridTransportStats", nfcHybridTransportStats.toDataItem())
    }
    return builder.end().build()
}

fun EventVerificationIso18013Proximity_fromDataItem(dataItem: DataItem): EventVerificationIso18013Proximity {
    val identifier = dataItem["identifier"].asTstr
    val timestamp = dataItem["timestamp"].asDateTimeString
    val map0 = dataItem["appData"].let {
        buildMap<String, DataItem> {
            for (entry in it.asMap.entries) {
                put(entry.key.asTstr, entry.value)
            }
        }
    }
    val appData = map0
    val presentmentRecord = PresentmentRecord.fromDataItem(dataItem["presentmentRecord"])
    val engagementType = EngagementType.valueOf(dataItem["engagementType"].asTstr)
    val durationNfcTapToEngagement0 = if (dataItem.hasKey("durationNfcTapToEngagement")) {
        dataItem["durationNfcTapToEngagement"].asNullable?.asTstr?.let { Duration.parse(it) }
    } else {
        null
    }
    val durationEngagementReceivedToRequestSent0 = if (dataItem.hasKey("durationEngagementReceivedToRequestSent")) {
        dataItem["durationEngagementReceivedToRequestSent"].asNullable?.asTstr?.let { Duration.parse(it) }
    } else {
        null
    }
    val durationRequestSentToResponseReceived0 = if (dataItem.hasKey("durationRequestSentToResponseReceived")) {
        dataItem["durationRequestSentToResponseReceived"].asNullable?.asTstr?.let { Duration.parse(it) }
    } else {
        null
    }
    val durationScanningTime0 = if (dataItem.hasKey("durationScanningTime")) {
        dataItem["durationScanningTime"].asNullable?.asTstr?.let { Duration.parse(it) }
    } else {
        null
    }
    val nfcHybridTransportStats0 = if (dataItem.hasKey("nfcHybridTransportStats")) {
        NfcHybridTransportStats.fromDataItem(dataItem["nfcHybridTransportStats"])
    } else {
        null
    }
    return EventVerificationIso18013Proximity(
        identifier = identifier,
        timestamp = timestamp,
        appData = appData,
        presentmentRecord = presentmentRecord,
        engagementType = engagementType,
        durationNfcTapToEngagement = durationNfcTapToEngagement0,
        durationEngagementReceivedToRequestSent = durationEngagementReceivedToRequestSent0,
        durationRequestSentToResponseReceived = durationRequestSentToResponseReceived0,
        durationScanningTime = durationScanningTime0,
        nfcHybridTransportStats = nfcHybridTransportStats0,
    )
}
